import React, { useContext } from 'react'

import TRow from './TRow'

import TableContext from './TContext'

const TBody = () => {
  const { prescriptions } = useContext(TableContext);

  return (
    <>
      {prescriptions.map(doc => <TRow key={doc._id || doc.id} doc={doc}  /> )}
    </>
  )
}

export default TBody